// extracted by mini-css-extract-plugin
module.exports = {"how_to_connect":"HowToConnect_how_to_connect__Rw8Xc"};